var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(!_vm.token) ? _c('form', {
    staticClass: "login-form",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.formSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login-input",
    attrs: {
      "type": "text",
      "placeholder": "username",
      "disabled": _vm.loggingIn
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "placeholder": "password",
      "disabled": _vm.loggingIn
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('router-link', {
    staticClass: "subtle-link",
    attrs: {
      "to": "/password-reset"
    }
  }, [_vm._v("Trouble logging in?")]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login({
          username: _vm.username,
          password: _vm.password
        })
      }
    }
  }, [_vm._v("\n        Log In\n      ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.token) ? _c('div', {
    staticClass: "login-form"
  }, [_vm._v("\n    " + _vm._s(_vm.token) + "\n    You are logged in.\n    "), _c('div', {
    staticClass: "form-actions"
  }, [_c('router-link', {
    staticClass: "subtle-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Log Out")])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      key: notification.message,
      staticClass: "login-message",
      class: {
        error: notification.type === 'error'
      }
    }, [_vm._v("\n    " + _vm._s(notification.message) + "\n    "), _c('button', {
      staticClass: "close-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clearNotifications()
        }
      }
    }, [_vm._v("x")])])
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f87b417","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = ibNe
// module chunks = 1